import m from "../../../@babel/runtime/helpers/esm/slicedToArray2.mjs";
import * as p from "react";
import { updateCSS as u, removeCSS as r } from "../../../rc-util/es/Dom/dynamicCSS.mjs";
import l from "../../../rc-util/es/hooks/useLayoutEffect.mjs";
import s from "../../../rc-util/es/getScrollBarSize.mjs";
import { isBodyOverflowing as d } from "./util.mjs";
var v = "rc-util-locker-".concat(Date.now()), a = 0;
function x(n) {
  var t = !!n, c = p.useState(function() {
    return a += 1, "".concat(v, "_").concat(a);
  }), e = m(c, 1), o = e[0];
  l(function() {
    if (t) {
      var i = s(), f = d();
      u(`
html body {
  overflow-y: hidden;
  `.concat(f ? "width: calc(100% - ".concat(i, "px);") : "", `
}`), o);
    } else
      r(o);
    return function() {
      r(o);
    };
  }, [t, o]);
}
export {
  x as default
};
//# sourceMappingURL=useScrollLocker.mjs.map
